const render = {
  listLabel1: 'Área Geral',
  listLabel2: 'Tabelas',
  listLabel3: 'Área do Usuário',
  listLabel4: 'Parâmetros',
  listLabel5: 'Sistema'
}

export default render;
